//login

import { apiClient } from './axios';
import { RoleResponse } from './role';
export interface LoginResponse {
  tokens: {
    token: string;
    refreshToken: string;
    expiresIn: string;
    tokenType: string;
  };
  user: {
    id: number;
    email: string;
    name: string;
    phoneNumber: string;
    role: RoleResponse  ;
  };
}

export const login = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('auth/login', {
    email,
    password,
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};
